import axios from "axios";
import Qs from "qs";

// Usa REACT_APP_API_URL si está definida. En producción por defecto apunta a api.floomind.com
const baseURL = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production'
    ? 'https://api.floomind.com/api'
    : 'http://localhost:8080/api');

export default axios.create({
    baseURL: baseURL,
    timeout: 50000,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
    paramsSerializer: params => Qs.stringify(params, {arrayFormat: 'repeat'})
})